import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AlertTriangle from "assets/img/svg/alertTriangle";
import classNames from "classnames";
import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import styles from "./style.module.scss";

interface IMessageBlock {
    type: "warning" | "error" | "info";
    text: string;
    /**
     * Link towards doc.
     */
    link?: string;
    style?: CSSProperties;
    /**
     * Removes left margin between text and doc button (needed when button is alone on its own line because of text length)
     */
    removeMarginFromDoc?: boolean;
    small?: boolean;
    /**
     * Action when clicking on button.
     */
    action?: () => void;
    actionText?: string;
}

/**
 * Message block (error, warning, info).
 */
const MessageBlock = ({
    type,
    text,
    link,
    style,
    removeMarginFromDoc = false,
    small = false,
    action,
    actionText,
}: IMessageBlock) => {
    const [t] = useTranslation();

    return (
        <div
            className={classNames({
                [styles["message-block"]]: true,
                [styles["error"]]: type === "error",
                [styles["warning"]]: type === "warning",
                [styles["info"]]: type === "info",
            })}
            style={{ ...style, paddingBlock: small ? "5px" : "12px" }}
        >
            {["error", "warning"].includes(type) && (
                <AlertTriangle
                    className={classNames({
                        [styles["warning-icon"]]: true,
                        [styles["error"]]: type === "error",
                        [styles["warning"]]: type === "warning",
                        [styles["info"]]: type === "info",
                    })}
                />
            )}
            <span>{text}</span>
            {type === "info" && link && (
                <a
                    className={styles["doc-link"]}
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    style={{ marginLeft: removeMarginFromDoc ? "0px" : "6px" }}
                >
                    {t("MessageBlock.More")} <KeyboardArrowRightIcon />
                </a>
            )}

            {action && (
                <span
                    onClick={action}
                    style={{ marginLeft: removeMarginFromDoc ? "0px" : "6px" }}
                    className={classNames({ [styles["doc-link"]]: true, [styles["red"]]: true })}
                >
                    {actionText ?? ""}
                </span>
            )}
        </div>
    );
};

export default MessageBlock;
